import { render, staticRenderFns } from "./SaveCompositionWindow.vue?vue&type=template&id=19429860"
import script from "./SaveCompositionWindow.vue?vue&type=script&lang=js"
export * from "./SaveCompositionWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports